export default "__VITE_ASSET__HpBp0LN3__"